module.exports = __webpack_public_path__ + "statics/img/TargetAudience-3.e14ee049.png";